var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-row',{staticStyle:{"height":"300px"},attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c('v-progress-circular',{staticClass:"mb-0",attrs:{"size":70,"indeterminate":"","color":"primary"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }